import { useEffect, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import { actionUpdateModalParams } from '../../../actions/modal_search';

const TickersModalSearch = () => {
  const [search, setSearch] = useState('');
  const inputRef = useRef<HTMLInputElement>(null);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(actionUpdateModalParams({ search: search }));
  }, [search]);

  return (
    <input
      type='search'
      className='tickers__panel__search text--14'
      id='tickers__panel__search'
      ref={inputRef}
      value={search}
      onChange={(e) => setSearch(e.target.value)}
      placeholder='Search...'
      autoComplete='off'
      autoFocus
    />
  );
};

export default TickersModalSearch;
